import axios from 'axios'

const state = {
  hiveTypes: [],
  identityTypes: [],
  identityTypesLoading: false,
  runStatuses: [],
  honeyPrivileges: [],
  hiveConnectionTypes: []
}

const mutations = {
  setHiveTypes(state, hiveTypes) {
    state.hiveTypes = hiveTypes
  },

  setIdentityTypes(state, identityTypes) {
    state.identityTypes = identityTypes
  },

  setIdentityTypesLoading(state, isLoading) {
    state.identityTypesLoading = isLoading
  },

  setRunStatuses(state, runStatuses) {
    state.runStatuses = runStatuses
  },

  setHoneyPrivileges(state, honeyPrivileges) {
    state.honeyPrivileges = honeyPrivileges
  },

  setHiveConnectionTypes(state, hiveConnectionTypes) {
    state.hiveConnectionTypes = hiveConnectionTypes
  }
}

let actions = {
  async fetchHiveConnectionTypes({ commit }) {
    let response = await axios.get('/api/v1/hiveConnectionTypes')
    let hiveConnectionTypes = response.data._embedded.enumReturnModels
    commit('setHiveConnectionTypes', hiveConnectionTypes)
    return hiveConnectionTypes
  },

  async fetchHoneyPrivileges({ commit }) {
    let response = await axios.get('/api/v1/honeyPrivileges')
    let honeyPrivileges = response.data._embedded.enumReturnModels
    commit('setHoneyPrivileges', honeyPrivileges)
    return honeyPrivileges
  },

  async fetchHiveTypes({ commit }) {
    let response = await axios.get('/api/v1/hiveTypes')
    let hiveTypes = response.data._embedded.enumReturnModels
    commit('setHiveTypes', hiveTypes)
    return hiveTypes
  },

  async fetchIdentityTypes({ commit }) {
    commit('setIdentityTypesLoading', true)
    let response = await axios.get('/api/v1/identityTypes')
    let identityTypes = response.data._embedded.enumReturnModels
    commit('setIdentityTypes', identityTypes)
    commit('setIdentityTypesLoading', false)
    return identityTypes
  },

  async fetchRunStatuses({ commit }) {
    let response = await axios.get('/api/v1/runStatuses')
    let runStatuses = response.data._embedded.enumReturnModels
    commit('setRunStatuses', runStatuses)
    return runStatuses
  }
}

export default {
  state,
  actions,
  mutations
}
